import type { ErrorInfo } from "../types";

type StackTraceProps = {
  errorInfo: ErrorInfo;
};

export function StackTrace({ errorInfo }: StackTraceProps) {
  const stack = errorInfo.devDetails.stack;

  if (!stack) {
    return null;
  }

  return (
    <div>
      <h4 className="mb-2 font-semibold text-red-800">Stack Trace:</h4>
      <pre className="max-h-96 w-full overflow-x-auto overflow-y-auto rounded bg-gray-900 p-4 text-xs text-green-400">
        <code>{stack}</code>
      </pre>
    </div>
  );
}
